module.exports = __webpack_public_path__ + "static/media/admin-1.b22ae529.jpg";